import { render } from "./ProductsComponent.vue?vue&type=template&id=63d69d71&scoped=true"
import script from "./ProductsComponent.vue?vue&type=script&lang=js"
export * from "./ProductsComponent.vue?vue&type=script&lang=js"

import "./ProductsComponent.vue?vue&type=style&index=0&id=63d69d71&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d69d71"]])

export default __exports__